export default __webpack_public_path__ + "assets/e664b3981d4930b55fa05e57cb4cacc2.svg";